import { useQuery } from "@tanstack/react-query"
import { fetchElectionCountdown, type ElectionCountdownResponse } from "QuorumGrassroots/services/grassrootsCampaign"

const electionCountdownKeys = {
    all: [{ _model: "gotvElectionCountdown" }] as const,
    detail: (campaignId: string) => [{ ...electionCountdownKeys.all[0], campaignId }] as const,
}

export const useElectionCountdown = (campaignId: string | undefined) => {
    return useQuery<ElectionCountdownResponse>({
        queryKey: electionCountdownKeys.detail(campaignId || ""),
        queryFn: fetchElectionCountdown,
        retry: false,
        enabled: Boolean(campaignId),
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    })
}
